// A corrective action's `sourceRef` is the platform's own key for what raised it
// ("response-room:<id>", "incident-review:<id>", "exercise-finding:<id>"). A person is shown what
// kind of record it was, never a database id (RES-12). Pure.

const ID_LIKE = /^c[a-z0-9]{20,}$/i;

export function sourceRefLabel(ref: string | null | undefined): string | null {
  if (!ref) return null;
  const parts = ref.split(":").map((p) => p.trim()).filter(Boolean);
  if (parts.length < 2) return ref;
  const [kind, ...rest] = parts;
  const kept = rest.filter((p) => !ID_LIKE.test(p));
  const name = kind.replace(/[-_]/g, " ").replace(/^\w/, (c) => c.toUpperCase());
  return kept.length ? `${name} ${kept.join(" ")}` : name;
}
